import type { Price } from '@backmarket/http-api/src/api-models/Price'
import type { Picker } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { calculateReduction } from '@backmarket/utils/math/calculateReduction'

import { normalizePrice } from '../../helpers/normalizePrice/normalizePrice'

import translations from './applyDealsToPickersGroup.translations'

export function applyDealsToPickerGroup(
  group: Picker,
  i18n: ReturnType<typeof useI18n>,
): Picker {
  const items = group.items.map((item) => {
    const deal = item.deals?.[0]

    if (deal?.type === 'seller_flash_sales') {
      return {
        ...item,
        tag: {
          label: i18n(translations.sellerFlashSalesTag),
          type: 'success' as const,
        },
      }
    }

    if (deal?.type === 'flash_sales') {
      let flashSalesPrice: Price | undefined

      if (item.price) {
        const normalizedDiscount = normalizePrice(deal.discount)
        const discountedPrice = calculateReduction(
          item.price,
          normalizedDiscount,
        )

        if (discountedPrice) {
          flashSalesPrice = discountedPrice
        }
      }

      return {
        ...item,
        ...(flashSalesPrice && { price: flashSalesPrice }),
      }
    }

    return item
  })

  return { ...group, items }
}
